import { AlertTriangle, Radio } from 'lucide-react';
import { HoverPopoverIcon } from '@/components/hover-popover-icon';
import { useI18nContext } from '@/i18n/i18n-react';
import type { CampaignDto } from '@/generated/korza-api-client/types.gen';

type CampaignAnalyticsWarningsProps = {
  analytics: CampaignDto['analytics'];
  closeOnScroll?: boolean;
};

export function CampaignAnalyticsWarnings({
  analytics,
  closeOnScroll = false,
}: CampaignAnalyticsWarningsProps) {
  const { LL } = useI18nContext();
  const {
    shouldShowWarning,
    minAppVersion,
    percentageOfUsersWithAnalyticsDataCollection,
  } = analytics.dataSufficiency;

  const dataSufficiencyMessage =
    LL.metricsPage.warnings.dataSufficiencyCampaign({
      version: minAppVersion,
      percentage: Math.round(
        percentageOfUsersWithAnalyticsDataCollection * 100
      ),
    });

  const unsettledMessage = LL.metricsPage.warnings.unsettledCampaign();

  return (
    <>
      {shouldShowWarning && (
        <HoverPopoverIcon
          icon={AlertTriangle}
          ariaLabel={dataSufficiencyMessage}
          message={dataSufficiencyMessage}
          closeOnScroll={closeOnScroll}
        />
      )}
      {!analytics.isSettled && (
        <HoverPopoverIcon
          icon={Radio}
          ariaLabel={unsettledMessage}
          message={unsettledMessage}
          variant="primary"
        />
      )}
    </>
  );
}
